// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"1a5d7320","233":"316518d1","371":"dc14c505","453":"5c092c9e","485":"e609cfe4","867":"80617014","915":"793867ce","998":"e108c89e"}[chunkId] + ".chunk.js";
};